/** @jsx jsx */

import { jsx, Box } from 'theme-ui'
import Select, { components } from 'react-select'
import Paragraph from '../shared/Typography/Paragraph/Paragraph'
import theme from '../../gatsby-plugin-theme-ui'

const customStyles = {
  control: (base, state) => ({
    ...base,
    paddingLeft: '-10px',
    fontSize: '12px',
    lineHeight: '16px',
    border: '0 !important',
    boxShadow: '0 !important',
    '&:hover': {
      border: '0 !important',
    },
    float: 'center',
  }),
  menu: provided => ({
    ...provided,
    borderRadius: 0,
  }),
  option: provided => ({
    ...provided,
    fontSize: '12px',
    lineHeight: '16px',
    borderRadius: 0,
    background: theme.colors.background,
    color: 'black',
    '&:hover': {
      background: theme.colors.lightestGray,
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,

    color: state.isDisabled && 'black',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: 'black',
    display: state.isDisabled && 'none',
  }),
}

const SingleValue = ({ children, ...props }) => {
  return (
    <components.SingleValue {...props}>
      {children} {props.customValueLabel}
    </components.SingleValue>
  )
}

const ProductDropdown = props => {
  return (
    <Box sx={{ border: 'commentBorder', my: '5px' }} {...props}>
      <Paragraph
        variant="caption"
        sx={{
          mt: '12px',
          ml: '10px',
          display: 'inline',
          float: 'left',
          fontWeight: 'bold',
        }}
      >
        {props.selectionTitle}
      </Paragraph>
      <Select
        {...props}
        isSearchable={false}
        styles={customStyles}
        components={{
          IndicatorSeparator: () => null,
          SingleValue: propss => (
            <SingleValue
              {...propss}
              customValueLabel={props.customValueLabel}
            />
          ),
        }}
        placeholder={
          <Paragraph sx={{ color: '#3B3A38' }}>{props.placeholder}</Paragraph>
        }
      />
    </Box>
  )
}

export default ProductDropdown
